import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/calendarDetail/modal_close.svg';
const ModalCloseSvg = () => React.createElement(IconSvg, null);
export default ModalCloseSvg;
